import { ArrowLeftOutlined, MailOutlined } from '@ant-design/icons';
import { Alert, Button, Divider, Form, Input, Result, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './AuthForms.less';

const { Title, Text, Link } = Typography;

const ForgotPasswordForm = ({ onSwitchToLogin, onClose }) => {
  const [form] = Form.useForm();
  const { forgotPassword, isLoading, error, clearError } = useAuth();
  const [emailSent, setEmailSent] = useState(false);
  const [sentEmail, setSentEmail] = useState('');

  const handleSubmit = async (values) => {
    clearError();

    const result = await forgotPassword(values.email);
    
    if (result.success) {
      setEmailSent(true);
      setSentEmail(values.email);
      form.resetFields();
    }
  };

  const handleFieldChange = () => {
    if (error) {
      clearError();
    }
  };

  if (emailSent) {
    return (
      <div className="auth-form">
        <Result
          status="success"
          title="重置邮件已发送"
          subTitle={
            <Space direction="vertical" style={{ textAlign: 'center' }}>
              <Text>
                我们已向 <Text strong>{sentEmail}</Text> 发送了密码重置链接
              </Text>
              <Text type="secondary">
                请检查您的邮箱（包括垃圾邮件文件夹），并点击链接重置密码
              </Text>
              <Text type="secondary" style={{ fontSize: '12px' }}>
                链接将在24小时后过期
              </Text>
            </Space>
          }
          extra={[
            <Button key="back" onClick={onSwitchToLogin}>
              返回登录
            </Button>,
            <Button 
              key="resend" 
              type="primary" 
              onClick={() => {
                setEmailSent(false);
                setSentEmail('');
                form.setFieldsValue({ email: sentEmail });
              }}
            >
              重新发送
            </Button>,
          ]}
        />
      </div>
    );
  }

  return (
    <div className="auth-form">
      <div className="auth-form-header">
        <Title level={3}>忘记密码</Title>
        <Text type="secondary">输入您的邮箱地址，我们将发送重置密码的链接</Text>
      </div>

      {error && (
        <Alert
          message={error}
          type="error"
          showIcon
          closable
          onClose={clearError}
          style={{ marginBottom: 16 }}
        />
      )}

      <Form
        form={form}
        name="forgot-password"
        onFinish={handleSubmit}
        onFieldsChange={handleFieldChange}
        autoComplete="off"
        size="large"
        layout="vertical"
      >
        <Form.Item
          name="email"
          label="邮箱地址"
          rules={[
            { required: true, message: '请输入邮箱地址' },
            { type: 'email', message: '请输入有效的邮箱地址' }
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder="请输入注册时使用的邮箱地址"
            autoComplete="email"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            block
            size="large"
          >
            {isLoading ? '发送中...' : '发送重置链接'}
          </Button>
        </Form.Item>
      </Form>

      <Divider plain>
        <Text type="secondary">其他选项</Text>
      </Divider>

      <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
        <Link onClick={onSwitchToLogin}>
          <ArrowLeftOutlined style={{ marginRight: 4 }} />
          返回登录
        </Link>
        
        <Text type="secondary" style={{ fontSize: '12px' }}>
          如果您没有收到邮件，请检查垃圾邮件文件夹或联系客服
        </Text>
      </Space>
    </div>
  );
};

export default ForgotPasswordForm; 